import React, { useState } from 'react';
import Container from './container';
import LinkWithLogo from './UI/linkwithlogo';
import MapIco from '../img/location.svg';
import EmailIco from '../img/email.svg';
import LogoBlack from './UI/logoblack';
import LogoX from '../img/x.svg';
import ContextWindow from './contextwindow';
import Subtext from './UI/subtext';
import LogoIn from '../img/in.svg';
import LogoGit from '../img/git.svg';
import { useNavigate } from 'react-router-dom';

const FooterMain = () => {

   const [threadContextVisibility, setThreadContextVisibility] = useState(false);
   const [FAQContextVisibility, setFAQContextVisibility] = useState(false)

   const router = useNavigate();
   function toBest() {
      router("/chart", 0)
      window.scroll(0, 0)
   }
   function toMain() {
      router("/main", 0)
      window.scroll(0, 0)
   }

   return (
      <div className='bg-black pt-[60px] pb-[60px] sm:pb-[78px]'>
         {/*  [&>*]:absolute [&>*]:h-full  [&>*]:w-full [&>*]:left-0 [&>*]:top-0 [&>*]:z-50 */}
         <div className=''>
            <ContextWindow title="Oops!" visibility={threadContextVisibility} setvisibility={setThreadContextVisibility}>
               <div className='felex flex-col items-center justify-center text-center'>
                  <Subtext>Thread isn't available right now. We'll add it later. Thanks for your patience!</Subtext>
               </div>
            </ContextWindow>
            <ContextWindow title="Oops!" visibility={FAQContextVisibility} setvisibility={setFAQContextVisibility}>
               <div className='felex flex-col items-center justify-center text-center'>
                  <Subtext>FAQ Unavailable Right Now. We'll Add It Later. Thanks for Your Patience! <br />༼ つ ◕_◕ ༽つ</Subtext>
               </div>
            </ContextWindow>
         </div>
         <Container>
            <div className='flex flex-col items-center sm:items-start sm:grid sm:grid-cols-3 gap-[50px] sm:gap-0'>
               <div className='flex items-center sm:items-start  flex-col gap-[15px] order-2 sm:order-1'>
                  <h1 className='font-[Satoshi] text-white font-medium text-[20px] select-none'>Contacts:</h1>
                  <LinkWithLogo className="">Nightlife, Maribor</LinkWithLogo>
                  <LinkWithLogo className='sm:p-0 px-[22px]' src={MapIco}>Here will be our address</LinkWithLogo>
                  <LinkWithLogo href="mailto:nightlife.clientservice@gmail.com " src={EmailIco}>nightlife.clientservice@gmail.com</LinkWithLogo>
               </div>
               <div className='m-auto order-1 sm:order-2 select-none items-center flex flex-col justify-between font-[Satoshi] text-[20px] text-white font-medium
               '>
                  <LogoBlack onClick={toMain} className=' cursor-pointer transition duration-100 ease-linear hover:drop-shadow-[0px_0px_5px_white]' />
                  <span onClick={toBest} className='cursor-pointer transition duration-100 ease-linear hover:drop-shadow-[0px_0px_5px_white] '>Best</span>
                  <span className='cursor-pointer transition duration-100 ease-linear hover:drop-shadow-[0px_0px_5px_white]' onClick={() => { setThreadContextVisibility(true); }}>Thread</span>
                  <span className='cursor-pointer transition duration-100 ease-linear hover:drop-shadow-[0px_0px_5px_white]' onClick={() => { setFAQContextVisibility(true) }}>FAQ</span>
               </div>

               <div className='order-3 flex flex-col justify-end sm:self-end items-center sm:items-end'>
                  <div className='flex gap-[10px] mb-[20px]'>
                     <a target='_blank' href="https://twitter.com/derhachov_dev"><img src={LogoX} alt="" /></a>
                     <a target='_blank' href="https://www.linkedin.com/in/fedir-derhachov"><img src={LogoIn} alt="" /></a>
                     <a target='_blank' href="https://github.com/fdergachev"><img src={LogoGit} alt="" /></a>
                  </div>
                  <div className='select-none font-[Satoshi] text-[18px] font-light text-white'>
                     ©Fedir Derhachov 2024
                  </div>
               </div>
            </div>
         </Container>
      </div>
   );
};

export default FooterMain;